import { INPUT } from '$gbusiness/enums';
import { DOC_TYPE_OPTIONS } from '$fbusiness/enums/options/docType';

export const FILE_EDIT_FORM = [
  {
    items: [
      {
        input: INPUT.TEXT,
        label: 'SCREEN.FILES.COLS.NAME',
        value: 'name',
        gridSize: 12,
      },
      {
        input: INPUT.TEXT,
        label: 'SCREEN.FILES.COLS.DESCRIPTION',
        value: 'description',
        gridSize: 12,
      },
      {
        input: INPUT.SELECT,
        label: 'SCREEN.FILES.COLS.TYPE',
        value: 'docType',
        options: DOC_TYPE_OPTIONS,
        gridSize: 6,
      },
      {
        input: INPUT.CHECKBOX,
        label: 'SCREEN.FILES.COLS.PROTECTED',
        value: 'isProtected',
        gridSize: 6,
      },
      {
        input: INPUT.TEXT,
        label: 'SCREEN.FILES.COLS.PASSCODE',
        value: 'passcode',
        gridSize: 12,
        isHidden: (vals) => !vals?.isProtected,
      },
    ],
  },
];

export default FILE_EDIT_FORM;
